export default palette => ({
  toolbar: {
    backgroundColor: palette.background.paper,
  },
})
